module.exports = __webpack_public_path__ + "static/media/subscript.06a51a5c.svg";